module.exports =
{
  bedrooms: require('./PodConfigurator/bedrooms'),
  bedroomsModal: require('./PodConfigurator/bedroomsModal'),
  experience: require('./PodConfigurator/experience'),
  experienceModal: require('./PodConfigurator/experienceModal'),
  confirm: require('./PodConfigurator/confirm'),
  confirmModal: require('./PodConfigurator/confirmModal'),
  modals: require('./PodConfigurator/modals'),
  terms: require('./PodConfigurator/terms'),
  sendEmail: require('./PodConfigurator/sendEmail'),
}